var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/status/containers/quoted_status_container.tsx";
import React from 'react';
import QuotedStatus from 'soapbox/components/quoted-status';
import { useAppSelector } from 'soapbox/hooks';
import { makeGetStatus } from 'soapbox/selectors';
const getStatus = makeGetStatus();
const QuotedStatusContainer = ({
  statusId
}) => {
  const status = useAppSelector(state => getStatus(state, {
    id: statusId
  }));
  if (!status) {
    return null;
  }
  return /*#__PURE__*/React.createElement(QuotedStatus, {
    status: status,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  });
};
export default QuotedStatusContainer;